import {getEnvironment} from "./environmantDetection";
import API_CONSTANTS from "./../constants/constants";
import axios from "axios";

// create request body for liking the shared project
const createLikeBody = (userId) => {
    return {
        "postId": "",
        "userId": userId
    }
}

const getLikeId = (users, userId) => {
    for (var i = 0; i < users.length; i++) {
        if (users[i].userId === userId) {
            return users[i].id;
        }
    }
    return null;
}

const defaultHeaders = {}

const serverCalls = {
    baseUrl: "https://" + getEnvironment("API") + "shutterfly.com",
    getUrlVars() {
        var vars = {};
        var parts = window.location.href.replace(
            /[?&]+([^=&]+)=([^&]*)/gi,
            function (m, key, value) {
                vars[key] = value;
            }
        );
        return vars;
    },
    getData(urlEndPoint) {
        let shareId = this.getUrlVars()["shareid"];
        return fetch(this.baseUrl + urlEndPoint + shareId, {
            method: "GET",
            headers: {
                "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
                "SFLY-Apikey": API_CONSTANTS.SHARE_API_CONFIG
            }
        })
            .then(response => response)
            .then(res => {
                if (res.status === 200) {
                    return res.json();
                } else {
                    return "error";
                }
            });
    },
    getSalePrice(urlEndPoint, accessToken) {
            let shareId = this.getUrlVars()["shareid"];
            return fetch(this.baseUrl + urlEndPoint + shareId, {
                method: "GET",
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
                    "Authorization": "Bearer " + accessToken
                }
            })
                .then(response => response)
                .then(res => {
                    if (res.status === 200) {
                        return res.json();
                    } else {
                        return "error";
                    }
                });
        },
    addToCart(params, body) {
        //create a clone of the shared project before adding to cart
        var headers = {
            "Content-Type": "application/json",
            "SFLY-Apikey": API_CONSTANTS.PROJECT_SERVICES_API_CONFIG, // TODO replaced from config
            "SFLY-CALLER-ID": API_CONSTANTS.SHARE_API_CALLER_ID,
            authorization: `Bearer ${params.token}`
        };
        let baseUrl = API_CONSTANTS.PROJECT_SERVICES_URL + body.userId + "/projects";

        return axios
            .post(
                baseUrl,
                {
                    projectGUID: body.projectGuid,
                    copyProjectGroup: "USER",
                    copiedProjectStatus: "ACTIVE"
                },
                {headers: headers}
            )
            .then(function (response) {
                if (response.status === 201) {
                    body.projectGuid = response.data.projectMetadata.guid;
                    const options = {
                        method: "POST",
                        credentials: "same-origin",
                        headers: {
                            "Content-Type": "application/json",
                            "SFLY-Apikey": API_CONSTANTS.CART_API_CONFIG, // TODO replaced from config
                            authorization: `Bearer ${params.token}`
                        },
                        body: JSON.stringify(body)
                    };
                    return fetch(API_CONSTANTS.ADD_TO_CART_URL, options)
                        .then(response => response)
                        .then(res => {
                            if (res.status === 200) {
                                return res.json();
                            } else {
                                return res.json().then(data => {
                                    return {
                                        error: true,
                                        response: data,
                                        status: res.status
                                    };
                                });
                            }
                        });
                }
            })
            .catch(function (error) {
                console.log(error);
            });
    },

    getGCDRepositories: () => {
        return fetch(API_CONSTANTS.GET_CGD_REPOSITORY_UPDATES, {
            method: "GET",
            headers: {
                "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
            }
        }).then(res => {
            return res.json();
        });
    },

    getProductDescription: function () {
        let shareId = this.getUrlVars()["shareid"]
        return fetch(this.baseUrl + "/share/v1/productDetail/" + shareId, {
            method: "GET",
            headers: {
                "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
                "SFLY-Apikey": API_CONSTANTS.SHARE_API_CONFIG
            }
        }).then(res => {
            return res.json();
        })
    },

    likeSharedProduct: function (userId) {
        let shareId = this.getUrlVars()["shareid"];
        const url = API_CONSTANTS.LIKE_COMMENT_BASE_URL + shareId + '/likes';
        const body = createLikeBody(userId);
        return axios.post(url, body, defaultHeaders);
    },

    unlikeSharedProduct: function (users, currentUser) {
        let shareId = this.getUrlVars()["shareid"];
        const likeId = getLikeId(users, currentUser);
        const url = API_CONSTANTS.LIKE_COMMENT_BASE_URL + shareId + '/likes/' + likeId;
        return axios.delete(url, defaultHeaders);
    },

    getLikes: function () {
        let shareId = this.getUrlVars()["shareid"];
        const url = API_CONSTANTS.LIKE_COMMENT_BASE_URL + shareId + '/likes';
        return axios.get(url, defaultHeaders);
    }


};

export default serverCalls;
